import PropTypes from 'prop-types';
import { PrimaryButton, SecondaryButton } from 'jl-design-system/elements/button/Button';

import styles from './FormEditButtons.scss';

export const FormCancelButtons = ({ cancelHandler, saveEditingHandler, extraClassName = '' }) => (
  <div className={[styles.FormEditButtons, extraClassName].join(' ')} data-testid="FormEditButtons">
    <SecondaryButton inline className={styles.CancelCancelButton} onClick={cancelHandler}>
      No, keep appointment
    </SecondaryButton>
    <PrimaryButton inline className={styles.CancelSaveButton} onClick={saveEditingHandler}>
      Yes, cancel
    </PrimaryButton>
  </div>
);

FormCancelButtons.propTypes = {
  cancelHandler: PropTypes.func.isRequired,
  saveEditingHandler: PropTypes.func.isRequired,
  extraClassName: PropTypes.string,
};
